import React from "react";

export default function UserSubmitErrorMessage({ response, locale = "pt-BR" }) {
	const errors = {
		messages: {
			"The E-mail is already in use. Please enter a unique E-mail.": {
				"pt-BR": "O E-mail já está em uso. Digite um E-mail exclusivo.",
				"en-US":
					"The E-mail is already in use. Please enter a unique E-mail",
			},
			"The CPF is already in use. Please enter a unique CPF.": {
				"pt-BR": "O CPF já está em uso. Digite um CPF exclusivo.",
				"en-US":
					"The CPF is already in use. Please enter a unique CPF.",
			},
			"The Matrícula SIAPE is already in use. Please enter a unique Matrícula SIAPE.":
				{
					"pt-BR":
						"O Matrícula SIAPE já está em uso. Digite um Matrícula SIAPE exclusivo.",
					"en-US":
						"The Matrícula SIAPE is already in use. Please enter a unique Matrícula SIAPE",
				},
			"The Matrícula PCDF is already in use. Please enter a unique Matrícula PCDF.":
				{
					"pt-BR":
						"O Matrícula PCDF já está em uso. Digite um Matrícula PCDF exclusivo.",
					"en-US":
						"The Matrícula PCDF is already in use. Please enter a unique Matrícula PCDF",
				},
			"The Matrícula Instituidor is already in use. Please enter a unique Matrícula Instituidor.":
				{
					"pt-BR":
						"O Matrícula Instituidor já está em uso. Digite um Matrícula Instituidor exclusivo.",
					"en-US":
						"The Matrícula Instituidor is already in use. Please enter a unique Matrícula Instituidor",
				},
			"O E-mail já está em uso. Digite um E-mail exclusivo.": {
				"pt-BR": "O E-mail já está em uso. Digite um E-mail exclusivo.",
				"en-US":
					"The E-mail is already in use. Please enter a unique E-mail",
			},
			"O CPF já está em uso. Digite um CPF exclusivo.": {
				"pt-BR": "O CPF já está em uso. Digite um CPF exclusivo.",
				"en-US":
					"The CPF is already in use. Please enter a unique CPF.",
			},
			"O Matrícula SIAPE já está em uso. Digite um Matrícula SIAPE exclusivo.":
				{
					"pt-BR":
						"O Matrícula SIAPE já está em uso. Digite um Matrícula SIAPE exclusivo.",
					"en-US":
						"The Matrícula SIAPE is already in use. Please enter a unique Matrícula SIAPE",
				},
			"O Matrícula PCDF já está em uso. Digite um Matrícula PCDF exclusivo.":
				{
					"pt-BR":
						"O Matrícula PCDF já está em uso. Digite um Matrícula PCDF exclusivo.",
					"en-US":
						"The Matrícula PCDF is already in use. Please enter a unique Matrícula PCDF",
				},
			"O Matrícula Instituidor já está em uso. Digite um Matrícula Instituidor exclusivo.":
				{
					"pt-BR":
						"O Matrícula Instituidor já está em uso. Digite um Matrícula Instituidor exclusivo.",
					"en-US":
						"The Matrícula Instituidor is already in use. Please enter a unique Matrícula Instituidor",
				},
			'No value was provided for required object field "nome"': {
				"pt-BR":
					"Um nome não foi fornecido para o cadastro, verifique o envio",
				"en-US":
					"A name was not provided for registry, check your submission	",
			},
			"CPF do dependente é obrigatório": {
				"pt-BR": "CPF do dependente é obrigatório",
				"en-US": "Dependent's CPF is required",
			},
			"Parentesco do dependente é obrigatório": {
				"pt-BR": "Parentesco do dependente é obrigatório",
				"en-US": "Dependent's family relationship is required",
			},
			"Data de nascimento do dependente é obrigatório": {
				"pt-BR": "Data de nascimento do dependente é obrigatório",
				"en-US": "Dependent's birth date is required",
			},
			default: {
				"pt-BR": "Verifique os campos cadastrados e tente novamente",
				"en-US": "Check the entered data and try again",
			},
		},
		default: {
			messages: {
				error: {
					"pt-BR": "Ocorreu um erro, tente novamente",
					"en-US":
						"Submission could not be completed, please try again later",
				},
			},
		},
	};

	if (!response) {
		return <span>Erro inesperado</span>;
	}

	let errorMessage = null;

	if (response.title && errors.messages[response.title]?.[locale]) {
		errorMessage = errors.messages[response.title][locale];
	} 
	else if (response.message && errors.messages[response.message]?.[locale]) {
		errorMessage = errors.messages[response.message][locale];
	} 
	else if (response.detail) {
		try {
			const parsedDetail = JSON.parse(response.detail);
			if (Array.isArray(parsedDetail) && parsedDetail.length > 0) {
				const detailMessage = parsedDetail[0]?.errorMessage;
				if (detailMessage && errors.messages[detailMessage]?.[locale]) {
					errorMessage = errors.messages[detailMessage][locale];
				} else {
					errorMessage = detailMessage;
				}
			}
		} catch (e) {
			errorMessage = response.detail;
		}
	}

	if (!errorMessage) {
		errorMessage = errors.messages.default[locale] || "Erro inesperado";
	}

	return <span>{errorMessage}</span>;
}
